import React, { Component } from 'react';

//componentes
import Header from './header'

class Index extends Component {

    render(){
        return(
            <div>
                <Header />
            </div>
        );
    }

}
export default Index;